"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveStepContext = void 0;
const react_1 = require("react");
exports.ActiveStepContext = (0, react_1.createContext)({
    activeStep: 0,
    setActiveStep: () => {
        return;
    },
});
